<template>
  <div class="ecm__profile">
    <div class="ecm__profile-container">
      <ChangeImageUser
        ref="changePhotoRef"
      />
      <div class="ecm__profile-container__image">
        <div class="ecm__profile-container__image__cover" @click="handleOpenChangeImage">
          <img v-if="user.image" :src="user.image">
        </div>
      </div>
      <div class="ecm__profile-container__bio">
        <button @click="handleModify" class="ecm__profile-container__bio-edit">
          <i v-if="!isReadOnly" class="fas fa-user-edit"></i>
          <i v-else class="fal fa-user-edit"></i>
        </button>
        <el-form
          class="ecm__profile-container__bio-form"
          :model="user"
          :rules="rules"
          ref="ruleForm"
          @submit.prevent.native="handleForm('ruleForm')"
        >
          <Input
            :isReadOnly="isReadOnly"
            ref="fullNameRef"
            :label="'Full Name'"
            :field="'full_name'"
            v-model="user.full_name"
          />
          <Input
            :isReadOnly="isReadOnly"
            ref="dateOfBirthRef"
            :label="'Date Of Birth'"
            :field="'date_of_birth'"
            :inputType="'date'"
            v-model="user.date_of_birth"
          />
          <Input
            :isReadOnly="isReadOnly"
            ref="genderRef"
            :label="'Gender'"
            :field="'gender'"
            :inputType="'radio'"
            :valueRadio="['Male', 'Female']"
            v-model="user.gender"
          />
          <Input
            :isReadOnly="isReadOnly"
            ref="emailRef"
            :label="'Email'"
            :field="'email'"
            v-model="user.email"
          />
          <Input
            :isReadOnly="isReadOnly"
            ref="phoneNumberRef"
            :label="'Phone Number'"
            :field="'phone_number'"
            v-model="user.phone_number"
          />
          <div class="ecm__profile-container__bio-form-actions">
            <button :disabled="isReadOnly" class="ecm__profile-container__bio-form-actions-btn submit" native-type="submit">Submit</button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/inputs/Input.vue'
import ChangeImageUser from '@/components/modals/ChangeImageUser'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'Profile',
  components: {
    Input,
    ChangeImageUser
  },
  data () {
    return {
      isReadOnly: true,
      rules: {
        full_name: [
          { required: true, message: 'Please input your full name', trigger: 'blur' }
        ],
        date_of_birth: [
          { required: true, message: 'Please input your date of birth', trigger: 'change' }
        ],
        gender: [
          { required: true, message: 'Please input your gender', trigger: 'change' }
        ],
        email: [
          { required: true, message: 'Please input your email', trigger: 'blur' },
          { type: 'email', message: 'email must be email format', trigger: 'blur' }
        ],
        phone_number: [
          { required: true, message: 'Please input your phone number', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  methods: {
    ...mapActions({
      updateUser: 'user/updateUser',
      fetchUser: 'user/fetchUser'
    }),
    ...mapMutations({
      setUserImage: 'user/setUserImage'
    }),
    handleForm (formName) {
      this.$refs[formName].validate( async (valid) => {
        if (valid) {
          try {
            const resp = await this.updateUser({
              userId: localStorage.getItem('userId'),
              payload: this.user
            })
            if (resp.msg === 'success update user') {
              this.$data.isReadOnly = true
              this.$message.success('Your profile has been changed successfully')
              this.handleFetchUser()
            }
          } catch (error) {
            console.log(error)            
          }
        } else {
          return false
        }
      })
    },
    handleOpenChangeImage () {
      this.$refs.changePhotoRef.setIsShow(true)
      this.setUserImage(this.user.image)
    },
    handleModify () {
      this.$data.isReadOnly = !this.$data.isReadOnly
    },
    async handleFetchUser () {
      try {
        const userId = localStorage.getItem('userId')
        if (userId) {
          await this.fetchUser({ userId })
        } else {
          throw { msg: 'user not found' }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__profile {
  .ecm__profile-container {
    display: flex;
    .ecm__profile-container__image,
    .ecm__profile-container__image__cover,
    .overlay-image {
      display: flex;
      justify-content: center;
    }
    .ecm__profile-container__image {
      justify-content: flex-start;
      width: 20%;
      height: 250px;
      .ecm__profile-container__image__cover {
        height: 200px;
        width: 200px;
        overflow: hidden;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        border: 1px solid var(--color-blue-background);
        img {
          height: 100%;
          width: 100%;
        }
      }
    }
    .ecm__profile-container__bio {
      width: 50%;
      position: relative;
      .ecm__profile-container__bio-edit {
        position: absolute;
        right: -50px;
        background: none;
        outline: none;
        border: none;
        font-size: 20px;
        cursor: pointer;
        color: var(--color-blue-background);
      }
    }
    .ecm__profile-container__bio-form-actions {
      display: flex;
      justify-content: flex-end;
      .ecm__profile-container__bio-form-actions-btn {
        border: none;
        outline: none;
        background: none;
        margin-right: 10px;
        padding: 7px 30px;
        font-size: 15px;
        font-weight: 500;
        cursor: pointer;
        &.reset {
          background: var(--color-yellow);
          color: var(--color-blue-background);
        }
        &.submit {
          background: var(--color-blue-background);
          color: white;
        }
        &:disabled,
        &.disabled {
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>